export default "__VITE_ASSET__6b2d5275__"